import { render, staticRenderFns } from "./ManageModifiers.vue?vue&type=template&id=543572aa&"
import script from "./ManageModifiers.vue?vue&type=script&lang=js&"
export * from "./ManageModifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports